import { useEffect, useState } from 'react';
import { getCehsAdmin, updateCeh, type CehRow } from './admin-api';
import { invalidateCehs } from './cehs';

// Правка одного цеха: название + описание. id (c1..c4) — структурный, не меняется.
function CehForm({ row, onSaved }: { row: CehRow; onSaved: () => void }) {
  const [name, setName] = useState(row.name);
  const [descr, setDescr] = useState(row.descr ?? '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const dirty = name.trim() !== row.name || descr.trim() !== (row.descr ?? '');

  async function save() {
    setBusy(true);
    setMsg(null);
    try {
      await updateCeh(row.id, name.trim(), descr.trim());
      invalidateCehs(); // другие экраны подхватят новое название
      onSaved();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Ошибка сохранения.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="glass pad" style={{ marginBottom: 12 }}>
      <div className="row" style={{ cursor: 'default', gap: 8 }}>
        <span className="mono muted" style={{ width: 30 }}>
          {row.id}
        </span>
        <input
          className="grow"
          value={name}
          disabled={busy}
          placeholder="Название цеха"
          onChange={(e) => setName(e.target.value)}
        />
        <button className="btn sm" disabled={busy || !dirty || !name.trim()} onClick={save}>
          Сохранить
        </button>
      </div>
      <input
        className="grow"
        style={{ width: '100%', marginTop: 8 }}
        value={descr}
        disabled={busy}
        placeholder="Описание (что делает цех)"
        onChange={(e) => setDescr(e.target.value)}
      />
      {msg && <p className="err">{msg}</p>}
    </div>
  );
}

export function CehsPanel() {
  const [cehs, setCehs] = useState<CehRow[] | null>(null);
  const load = () => getCehsAdmin().then((r) => setCehs(r.cehs));
  useEffect(() => {
    load();
  }, []);

  if (!cehs) return <p className="muted">Загрузка…</p>;

  return (
    <>
      <p className="muted small" style={{ marginBottom: 12 }}>
        Названия цехов отражаются на дашборде, в производстве и в карточке сделки. Состав (4 цеха)
        фиксирован — здесь меняются только названия и описания.
      </p>
      {cehs.map((c) => (
        <CehForm key={c.id} row={c} onSaved={load} />
      ))}
    </>
  );
}
